import React, { useState } from 'react';
import { NCZICompositionItem } from '../../../../Interfaces/ncziTypes';
import EHRNoItemsFound from '../../../EHR/EHRNoItemsFound';
import ElectronicExaminationVLSearchResultItem from './ElectronicExaminationVLSearchResultItem';

interface Props {
	patientIdentifier: string;
	items: NCZICompositionItem[];
	onCloseDetail: (needReload: boolean) => void;
}

const ElectronicExaminationVLSearchResultItems: React.FC<Props> = props => {
	const { items, onCloseDetail, patientIdentifier } = props;

	if (!items.length) {
		return (
			<>
				<EHRNoItemsFound />
			</>
		);
	}

	return (
		<>
			{items.map((item, key) => {
				if (!item.entry) {
					return <></>;
				}

				return (
					<ElectronicExaminationVLSearchResultItem
						key={key}
						item={item.entry}
						patientIdentifier={patientIdentifier}
						onCloseDetail={onCloseDetail}
					/>
				);
			})}
		</>
	);
};

export default ElectronicExaminationVLSearchResultItems;
